<template>
	<div>
		<div
			class="page-navbar navbar-white"
			:class="{ 'menu-nav-hidden': hideMenuNavigation }"
		>
			<div
				class="nav-center-wrapper"
				v-if="!isMobile || hideMenuNavigation"
			>
				<img class="navbar-logo" :src="$logoSrc" alt="getREEF Logo" />
			</div>
			<div
				class="navbar-content desktop-center"
				v-if="hideMenuNavigation"
			>
				<button
					class="button button-transparent user-menu-button"
					@click="openUserMenuModal"
				>
					<i class="sk-icon-bars-regular"></i>
				</button>
				<UserPicture @click.native="openUserMenuModal" :size="25" />
			</div>
			<div
				class="navbar-content desktop-center"
				v-if="!isMobile && !hideMenuNavigation"
			>
				<button
					class="button button-transparent user-menu-button"
					@click="openUserMenuModal"
				>
					<i class="sk-icon-bars-regular"></i>
				</button>
				<UserPicture @click.native="openUserMenuModal" :size="25" />
				<ResidentialDaySelector />
				<div class="menu-selector">
					<SkDropdownSelect
						v-model="selectedMenu"
						:classes="'menu-selector-dropdown'"
						:options="menuOptions"
					/>
				</div>
			</div>
			<div
				v-if="isMobile && !hideMenuNavigation"
				class="navbar-content desktop-center"
			>
				<button
					class="button button-transparent user-menu-button"
					@click="openUserMenuModal"
				>
					<i class="sk-icon-bars-regular"></i>
				</button>
				<UserPicture @click.native="openUserMenuModal" :size="25" />
				<div class="nav-center-wrapper">
					<ResidentialDaySelector />
				</div>
			</div>
			<div v-if="isMobile && !hideMenuNavigation" class="menu-selector">
				<SkDropdownSelect
					v-model="selectedMenu"
					:classes="'menu-selector-dropdown'"
					:options="menuOptions"
				/>
			</div>
		</div>
		<div class="navbar-spacer"></div>
		<UserMenuModal ref="userMenuModal" />
	</div>
</template>

<style>
.menu-selector-dropdown b {
	font-weight: 600;
	color: var(--gR-base-90);
	margin-right: 3px;
}

.menu-selector-dropdown .selected > span {
	display: flex;
}

.menu-selector-dropdown .ellipsify-text {
	max-width: 210px;
}

.menu-selector-dropdown .ellipsify-text + span {
	flex-shrink: 0;
}

@media (max-width: 1130px) {
	.menu-selector-dropdown .selected > span {
		width: 100%;
		justify-content: space-between;
	}

	.menu-selector-dropdown .selected {
		width: 100%;
	}
}

@media (min-width: 1125px) and (max-width: 1185px) {
	.menu-selector-dropdown .ellipsify-text {
		max-width: 70px;
	}
}

@media (min-width: 1185px) and (max-width: 1350px) {
	.menu-selector-dropdown .ellipsify-text {
		max-width: 100px;
	}
}

@media (max-width: 1130px) {
	.menu-selector-dropdown.sk-select {
		height: 50px !important;
	}
}
</style>

<style scoped>
.page-navbar >>> .user-profile-picture {
	margin-right: 15px;
	z-index: 2;
}

.menu-selector {
	font-size: 14px;
	color: var(--sk-grey3);
}

.menu-selector {
	margin-left: 75px;
}

@media (max-width: 1130px) {
	.menu-selector {
		margin-left: 0;
		box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
		padding: 0 30px;
	}

	.page-navbar:not(.menu-nav-hidden) + .navbar-spacer {
		height: 100px;
	}
}
</style>

<script>
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import navbarMixin from "@/mixins/navbar-mixin"
import ResidentialDaySelector from "@/components/common/ResidentialDaySelector.vue"
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"
import UserMenuModal from "@/components/modals/UserMenuModal.vue"
import UserPicture from "@/components/common/UserPicture.vue"

export default {
	name: "ResidentialMenuNavbar",
	mixins: [mobileResponsivenessMixin, navbarMixin],
	components: {
		ResidentialDaySelector,
		SkDropdownSelect,
		UserMenuModal,
		UserPicture
	},
	props: {
		hideMenuNavigation: {
			type: Boolean,
			default: false
		},
		menus: Array,
		menuIdInView: Number
	},
	data: function () {
		return {
			mobileThresholdWidth: 1130
		}
	},
	computed: {
		menuOptions() {
			return this.menus.map((menu) => {
				let timeRange = ""
				if (menu.timeSlots.length > 1) {
					timeRange = `${menu.timeSlots[0].text} - ${
						menu.timeSlots[menu.timeSlots.length - 1].text
					}`
				} else if (menu.timeSlots.length > 0) {
					timeRange = `${menu.timeSlots[0].text}`
				}
				return {
					id: menu.id,
					text: `<b>${menu.name}</b> from ${timeRange}`
				}
			})
		},
		selectedMenu: {
			get: function () {
				const selectedMenu = this.menuOptions.find(
					(menuOption) => menuOption.id == this.menuIdInView
				)
				if (selectedMenu) {
					return selectedMenu
				} else {
					return this.menuOptions && this.menuOptions[0]
						? this.menuOptions[0]
						: null
				}
			},
			set: function (menu) {
				if (menu && menu.id) {
					this.$emit("scrollToMenu", menu.id)
				}
			}
		}
	}
}
</script>